// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3CMZj","name":"ConsentHeader_name__2_cgz","birthday":"ConsentHeader_birthday__3mikM","skeleton":"ConsentHeader_skeleton__1ifB5"};